import { useState } from 'react'

export type Step = 'select-department' | 'register-uscis-case' | 'register-dol-case' | 'register-nvc-case' | 'register-eoir-case'

export const useContent = () => {
  const [step, setStep] = useState<Step>('select-department')

  return { step, setStep }
}
